/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Input_SourceInputs */



/**
* | output |
* | --- |
* | "Input Source" |
*
* @param {Options_Pedal_Input_SourceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_input_source = /** @type {((inputs?: Options_Pedal_Input_SourceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Input_SourceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Input Source")
	if (locale === "de") return /** @type {LocalizedString} */ ("Input Source")
	if (locale === "it") return /** @type {LocalizedString} */ ("Input Source")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Input Source")
	if (locale === "es") return /** @type {LocalizedString} */ ("Input Source")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Input Source")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Input Source")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Input Source")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Input Source")
	return /** @type {LocalizedString} */ ("Input Source")
});